import AngelImage from "../assets/images/angel.png";
import MuscleImage from "../assets/images/muscle.png";


const RevenueMatchImportance = [
    {
        id: 1,
        value: 'Important.',
        longValue: 'Important. I want to learn from others who are at my level.',
        backendValue: true,
        hasImage: true,
        image: MuscleImage
    },
    {
        id: 2,
        value: 'Not important.',
        longValue: 'Not important. I\'m open to learning from anyone.',
        backendValue: false,
        hasImage: true,
        image: AngelImage
    }
];

export default RevenueMatchImportance;